import { render, staticRenderFns } from "./DishMenus.vue?vue&type=template&id=7f65a83b&lang=pug"
import script from "./DishMenus.vue?vue&type=script&lang=js"
export * from "./DishMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports